module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"messages":{"title":"authentication is completed","message":"Twitter authentication is completed. When you log in from next time, please access <br /><b>{url}</b><br />.","okButton":"OK"}},"ja":{"messages":{"title":"Twitter認証完了","message":"Twitterアカウントの認証が完了しました。<br />次回以降ログインする際には、お送りしたメールアドレスに記載されたURLよりアクセスをお願いします。","okButton":"OK"}}}')
  delete Component.options._Ctor
}
